// Mirror of Documents::CaseExperience::StateChangePlanner.normalize_uid (Ruby is authoritative).
// Keep in sync with Documents::CaseExperience::StateChangePlanner.normalize_uid
// (spec/services/.../state_change_planner_spec.rb, spec/javascript/utils/case_experience_normalize_node_uid.spec.js)

const WHITESPACE_ONLY_UID_PREFIX = '_ws_';
const EMPTY_NORMALIZED_UID = '_ws_empty';

const bytesToHex = (raw) => {
  if (typeof TextEncoder !== 'undefined') {
    return Array.from(new TextEncoder().encode(raw), (byte) =>
      byte.toString(16).padStart(2, '0'),
    ).join('');
  }
  if (typeof Buffer !== 'undefined') {
    return Buffer.from(raw, 'utf8').toString('hex');
  }
  throw new Error('Unable to encode whitespace-only uid bytes');
};

export const normalizeNodeUid = (uid) => {
  if (uid == null) return EMPTY_NORMALIZED_UID;

  const raw = String(uid);
  if (raw.length === 0) return EMPTY_NORMALIZED_UID;

  const normalized = raw.split(/\s+/).filter(Boolean).join('-');
  if (normalized.length > 0) return normalized;

  return `${WHITESPACE_ONLY_UID_PREFIX}${bytesToHex(raw)}`;
};
